import React from "react";
import { useNavigate } from "react-router-dom";

const ParsedText = ({ text, className }) => {
	const navigate = useNavigate();

	if (!text) return null;

	// Split text by hashtags and mentions
	const parts = text.split(/([#@][\w]+)/g);

	return (
		<p className={className}>
			{parts.map((part, index) => {
				if (part.startsWith("#")) {
					return (
						<span
							key={index}
							style={{ color: "#00D1FF", cursor: "pointer", fontWeight: "600" }}
							onClick={(e) => {
								e.stopPropagation();
								navigate(`/Explore?tag=${part.substring(1)}`);
							}}
						>
							{part}
						</span>
					);
				} else if (part.startsWith("@")) {
					return (
						<span
							key={index}
							style={{ color: "#A6539D", cursor: "pointer", fontWeight: "500" }}
							onClick={(e) => {
								e.stopPropagation();
								// Since profiles are handled by username search or persona, we navigate to explore/search
								navigate(`/Explore?search=${part.substring(1)}`);
							}}
						>
							{part}
						</span>
					);
				}
				return part;
			})}
		</p>
	);
};

export default ParsedText;


